import {
    AiTextItem,
    ActionTypes,
    AiTextState,
    AiTextGenerateStartAction,
    AiTextGenerateEndAction,
    AiTextSetInputValueAction,
    AiTextGenerateStartCheckAction,
    AiTextGenerateWaitAction,
} from './types';
import { ApplicationState } from '..';

export const AiTextSetInputValue = (value: string): AiTextSetInputValueAction => ({
    type: ActionTypes.SET_INPUT_VALUE,
    payload: {
        value,
    },
});

export const AiTextGenerateStartCheck = (item: AiTextItem): AiTextGenerateStartCheckAction => ({
    type: ActionTypes.GENERATE_START_CHECK,
    payload: {
        item,
    },
});

export const AiTextGenerateStart = (item: AiTextItem): AiTextGenerateStartAction => ({
    type: ActionTypes.GENERATE_START,
    payload: {
        item,
    },
});

export const AiTextGenerateWait = (
    item: AiTextItem,
    conversationId: string,
    numberOfTries?: number
): AiTextGenerateWaitAction => ({
    type: ActionTypes.GENERATE_WAIT,
    payload: {
        item,
        conversationId,
        numberOfTries,
    },
});

export const AiTextGenerateEnd = (item: AiTextItem): AiTextGenerateEndAction => ({
    type: ActionTypes.GENERATE_END,
    payload: {
        item,
    },
});

export const getAiTextStore = (store: ApplicationState): AiTextState => store.aiText || ({} as AiTextState);
